// removed by extract-text-webpack-plugin
module.exports = {"cta__container":"cta__container","cta":"cta","cta__link":"cta__link"};


//////////////////
// WEBPACK FOOTER
// ./resources/views/library/components/cta/cta.scss
// module id = 1
// module chunks = 0 19